module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch24"
    }
  }, [_c('b', [_vm._v("Around the World")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Thirteen percent of the world’s population lives in deserts.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("World’s largest urban national park: Golden Gate National Recreation Area (74,820 acres).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Fifty-one countries were involved in World War II, the most of any war in human history.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Sweetwater, Texas, boasts the world’s largest rattlesnake roundup. The annual festival began in 1958 as a way for local farmers to get rid of rattlesnakes on their property. In the years since, it’s grown to include a parade, a snake-charmer competition, and a cook-off. (And they still collect snakes. More than 120 tons’ worth have been caught over the years.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("More people have seen magician David Copperfield perform live than any other entertainer in the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The "), _c('i', [_vm._v("Saturday Night Fever")]), _vm._v(" soundtrack has sold more than 30 million copies worldwide.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("World’s biggest army: China’s People’s Liberation Army, with 2.2 million active troops.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Since 1495, the world has never seen 25 consecutive years without at least one war.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3a7316c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter24.vue
// module id = 144
// module chunks = 0